import { REPORT_STATUS } from '../../constants/api';
import BaseEntity from './BaseEntity';
import Issue from './Issue';
export default class RawReport extends BaseEntity {
    constructor(data) {
        super();
        this.issues = [];
        this.language = null;
        this.output = null;
        this.errorCount = this.parseProperty(data, 'errorCount');
        this.id = this.parseProperty(data, 'id');
        if ('issues' in data && data.issues) {
            this.issues = this.parseProperty(data, 'issues').map(issue => new Issue(issue));
        }
        if ('language' in data && data.language) {
            this.language = this.parseProperty(data, 'language');
        }
        this.output = this.parseProperty(data, 'output');
        this.status = this.parseProperty(data, 'status');
        this.tool = this.parseProperty(data, 'tool');
        this.toolVersion = this.parseProperty(data, 'toolVersion');
        this.warningCount = this.parseProperty(data, 'warningCount');
    }
    getAnalysisMessage() {
        let message = '';
        switch (this.status) {
            case REPORT_STATUS.NEW:
                message = 'newAnalysis';
                break;
            case REPORT_STATUS.PROCESSING:
                message = 'analysisInProgress';
                break;
            case REPORT_STATUS.SUCCESS:
                message = 'analysisDone';
                break;
            case REPORT_STATUS.FAILURE:
                message = 'analysisFailed';
                break;
            case REPORT_STATUS.INVALID_CONFIG:
                message = 'analysisInvalidConfig';
                break;
            case REPORT_STATUS.TIMEOUT:
                message = 'analysisTimedOut';
                break;
        }
        return message;
    }
}
